module.exports = __webpack_public_path__ + "img/star_half_icon.40c4e015.svg";